<!-- eslint-disable vue/valid-v-else-if -->
<template>
  <div class="table-container">
    <el-row style="margin-bottom: 10px">
      <el-button
        icon="el-icon-printer"
        type="primary"
        size="mini"
        @click="handlePrintFunc"
      >
        批量打印发票
      </el-button>
      <el-button icon="el-icon-download" size="mini" @click="exportExcelFunc">
        导出EXCEL
      </el-button>
      <el-dropdown class="btn-group-item" @command="signPushFunc">
        <el-button size="mini">
          标记推送<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="PUSH">标记不推送</el-dropdown-item>
          <el-dropdown-item command="CANCEL_PUSH"
            >取消标记不推送</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        v-if="extensionNum !== '0'"
        class="btn-group-item"
        @command="pushSeedFunc"
      >
        <el-button size="mini">
          推送SEED<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="PUSH">标记推送SEED</el-dropdown-item>
          <el-dropdown-item command="CANCEL_PUSH"
            >取消推送SEED</el-dropdown-item
          >
          <el-dropdown-item command="MARKER"
            >标记已手工入账SEED</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        v-if="extensionNum !== '1'"
        class="btn-group-item"
        @command="pushSapFunc"
      >
        <el-button size="mini">
          推送SAP<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="PUSH">标记推送SAP</el-dropdown-item>
          <el-dropdown-item command="CANCEL_PUSH">取消推送SAP</el-dropdown-item>
          <el-dropdown-item command="MARKER"
            >标记已手工入账SAP</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        icon="el-icon-upload2"
        size="mini"
        class="btn-group-item"
        @click="importInvoiceFunc"
      >
        导入发票
      </el-button>
      <el-button
        icon="el-icon-document-checked"
        size="mini"
        @click="downloadPdfFunc"
      >
        下载pdf
      </el-button>
      <el-button
        icon="el-icon-edit"
        size="mini"
        class="btn-group-item"
        @click="updateSupplierFunc"
      >
        更新供应商
      </el-button>
    </el-row>

    <el-table
      ref="tableRef"
      border
      v-loading="listLoading"
      :data="list"
      :element-loading-text="elementLoadingText"
      :header-cell-style="{
        background: '#f0f2f5',
        color: '#333',
        height: '5px',
      }"
      size="mini"
      style="width: 100%"
      :height="590 + 'px'"
      @selection-change="setSelectedRows"
      @row-click="handleRowClick"
    >
      <template slot="empty">
        <el-empty :image-size="120" :image="img"></el-empty>
      </template>
      <el-table-column
        fixed="left"
        align="center"
        show-overflow-tooltip
        type="selection"
      ></el-table-column>
      <el-table-column
        fixed="left"
        align="center"
        width="50"
        show-overflow-tooltip
        type="index"
        label="序号"
      ></el-table-column>
      <el-table-column
        v-for="(col, index) in columns"
        :key="index"
        :type="col.type"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        :align="col.align"
        :fixed="col.fixed"
        show-overflow-tooltip
      >
        <!-- 通过 scoped slots 自定义单元格内容 -->
        <template v-slot="scope">
          <span v-if="col.prop === 'invoiceLine'">
            {{ formatColumn(scope.row, col.prop) }}
          </span>
          <span v-else-if="col.prop === 'selfOrderId'">
            <el-input
              v-if="scope.row.isEditingSelfOrderId"
              v-model="scope.row.selfOrderId"
              size="mini"
              placeholder="请输入订单号"
              maxlength="25"
              @blur="handleBlur(scope.row, 'selfOrderId')"
              @keyup.enter.native="$event.target.blur()"
            />
            <span
              v-else
              style="cursor: pointer"
              @click="toggleEdit(scope.row, 'selfOrderId')"
            >
              {{ scope.row.selfOrderId || "-" }}
            </span>
          </span>
          <el-tag
            v-else-if="col.prop === 'markerStatus'"
            size="medium"
            :type="getTagType(scope.row[col.prop])"
          >
            {{
              scope.row[col.prop] === 0
                ? "未推送"
                : scope.row[col.prop] === 1
                ? "已推送"
                : "不推送"
            }}
          </el-tag>
          <el-tag
            v-else-if="
              col.prop === 'seedPushStatus' || col.prop === 'sapPushStatus'
            "
            size="medium"
            :type="getTagType(scope.row[col.prop])"
          >
            {{
              scope.row[col.prop] === 0
                ? "未推送"
                : scope.row[col.prop] === 1
                ? "已推送"
                : "已手工入账"
            }}
          </el-tag>
          <el-tag
            v-else-if="col.prop === 'printStatus'"
            :type="getTagType(scope.row[col.prop])"
          >
            {{ scope.row[col.prop] === 0 ? "未打印" : "已打印" }}
          </el-tag>
          <span v-else>
            {{
              scope.row[col.prop] != null && scope.row[col.prop] !== ""
                ? scope.row[col.prop]
                : "-"
            }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNo"
      :page-size="queryForm.pageSize"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 导入发票 -->
    <input-invoice ref="inputInvoice" @fetch-data="fetchData" />

    <!-- 更新供应商 -->
    <update-supplier
      ref="updateSupplier"
      @fetch-data="fetchData"
      @clear-selected="clearSelectedRows"
    />

    <!-- 发票详情 -->
    <invoice-detail ref="invoiceDetail" />

    <!-- 隐藏的 iframe 用于加载 PDF -->
    <iframe :src="pdfUrl" style="display: none" ref="iframe"></iframe>
  </div>
</template>

<script>
import InputInvoice from "./components/inputInvoice.vue";
import UpdateSupplier from "./components/updateSupplier.vue";
import InvoiceDetail from "./components/invoiceDetail.vue";

const invoiceLineEnum = {
  p: "普通发票（电票）",
  c: "普通发票（纸质）",
  s: "专用发票（纸质）",
  b: "专用发票（电子）",
  bs: "数电专票（电子）",
  pc: "数电普票（电子）",
  es: "数电专票（纸质）",
  ec: "数电普票（纸质）",
};

export default {
  name: "CompareTableList",
  components: {
    InputInvoice,
    UpdateSupplier,
    InvoiceDetail,
  },
  data() {
    return {
      img: require("../../assets/images/empty.png"),
      list: null,
      listLoading: true,
      layout: "total, sizes, prev, pager, next, jumper",
      total: 0,
      selectedRows: [], // 存储勾选的表格数据
      elementLoadingText: "正在加载...",
      userId: "",
      extensionNum: "",
      pdfUrl: "", // 用于加载PDF的iframe地址
      queryForm: {
        pageNo: 1,
        pageSize: 20,
      },

      columns: [
        { prop: "supplierOwner", label: "供应商归属", width: 180 },
        { prop: "sellerName", label: "供应商名称", width: 200 },
        { prop: "elecInvoiceNumber", label: "数电发票号码", width: 150 },
        { prop: "invoiceCode", label: "发票代码", width: 180 },
        { prop: "invoiceNumber", label: "发票号码", width: 180 },
        { prop: "selfOrderId", label: "订单号", width: 180 },
        {
          prop: "taxAmountTotal",
          label: "含税金额",
          align: "right",
          width: 120,
        },
        { prop: "taxTotal", label: "税额", align: "right", width: 120 },
        {
          prop: "taxFreeAmountTotal",
          label: "未税金额",
          align: "right",
          width: 120,
        },
        { prop: "remark", label: "发票备注", width: 200 },
        {
          prop: "markerStatus",
          label: "标记推送",
          align: "center",
          width: 100,
        },
        {
          prop: "seedPushStatus",
          label: "推送seed状态",
          align: "center",
          width: 120,
        },
        {
          prop: "sapPushStatus",
          label: "推送sap状态",
          align: "center",
          width: 120,
        },
        { prop: "invoiceLine", label: "发票种类", width: 150 },
        { prop: "journalNo", label: "journal号", width: 180 },
        { prop: "invoiceTime", label: "发票日期", width: 180 },
        { prop: "erpEnterAccountTime", label: "发票入账日期", width: 180 },
        { prop: "markerTime", label: "发票推送日期", width: 180 },
        { prop: "printStatus", label: "打印标志", align: "center", width: 120 },
      ],
    };
  },

  created() {
    // console.log("链接带过来的query参数：", this.$route.query);
    // console.log("当前页路径：", window.location.href);
    // console.log("userId：", this.$route.query);

    const { userId, extensionNum } = this.$route.query;
    this.userId = userId;
    this.extensionNum = extensionNum;
  },

  updated() {
    this.$nextTick(() => {
      this.$refs["tableRef"].doLayout();
    });
  },

  methods: {
    /**
     * @description 切换编辑状态
     */
    toggleEdit(row, field) {
      if (field === "selfOrderId") {
        row.isEditingSelfOrderId = true;
      }
    },

    /**
     * @description 失去焦点时保存
     */
    handleBlur(row, field) {
      if (field === "selfOrderId") {
        row.isEditingSelfOrderId = false;
        this.saveEdit(row, "selfOrderId");
      }
    },

    /**
     * @description 保存编辑
     */
    saveEdit(row, field) {
      const params = {
        userId: this.userId,
        id: row.id,
      };

      if (field === "selfOrderId") {
        params.selfOrderId = row.selfOrderId;
      }

      this.$api
        .post(
          "/input/income-pool-invoice-basic-info-new/updateInvoiceInfo",
          params,
        )
        .then(() => {
          this.$message.success("修改订单号成功");
          const { searchData } = this.$store.state.CompareInvoicePool;
          this.fetchData(searchData);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    /**
     * @description 监听表格勾选变化
     */
    setSelectedRows(val) {
      this.selectedRows = val;
    },

    /**
     * @description 清空选中行
     */
    clearSelectedRows() {
      this.selectedRows = [];
    },

    /**
     * @description 获取列表数据
     */
    async fetchData(searchData) {
      this.listLoading = true;

      var params = Object.assign({
        ...searchData,
        ...this.queryForm,
        extensionNum: this.extensionNum,
      });

      params.userId = this.userId;
      this.$api
        .post("/input/income-pool-invoice-basic-info-new/queryList", params)
        .then((res) => {
          console.log("res", res);
          this.listLoading = false;
          this.list = (res.data.records || []).map((item) => ({
            ...item,
            isEditingInvoiceNumber: false,
            isEditingSelfOrderId: false,
          }));
          this.total = res.data.total;
        })
        .catch((err) => {
          this.$message.error(err.message);
          console.log("err", err);
          this.listLoading = false;
        });
    },

    /**
     * @description 改变列表每页显示条数
     */
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      const { searchData } = this.$store.state.CompareInvoicePool;
      // 存储 pageSize 和 pageNo 用于后续操作完成后刷新数据
      this.$store.commit(
        "CompareInvoicePool/COMPARE_INVOICE_POOL_SEARCH_DATA",
        {
          ...searchData,
          pageSize: val,
          pageNo: this.queryForm.pageNo,
        },
      );
      this.fetchData(searchData);
    },

    /**
     * @description 改变列表页数
     */
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      const { searchData } = this.$store.state.CompareInvoicePool;
      // 存储 pageSize 和 pageNo 用于后续操作完成后刷新数据
      this.$store.commit(
        "CompareInvoicePool/COMPARE_INVOICE_POOL_SEARCH_DATA",
        {
          ...searchData,
          pageSize: this.queryForm.pageSize,
          pageNo: val,
        },
      );
      this.fetchData(searchData);
    },

    /**
     * @description 监听表格行点击事件
     */
    handleRowClick(row) {
      if (row.isEditingInvoiceNumber || row.isEditingSelfOrderId) {
        return;
      }
      this.$refs.invoiceDetail.showDetailDialog(row);
    },

    /**
     * @description 格式化列表内容
     */
    formatColumn(row, column) {
      if (column === "invoiceLine") {
        return invoiceLineEnum[row.invoiceLine]; // 根据枚举映射显示
      }
      return row[column]; // 默认返回原始值
    },

    /**
     * @description 根据 printStatus 的状态返回不同的标签类型
     */
    getTagType(value) {
      if (value === 0) return "";
      if (value === 1) return "success";
      if (value === 2) return "warning";
      return "";
    },

    /**
     * @description 批量打印发票
     */
    async handlePrintFunc() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      try {
        let params = {
          ids: this.selectedRows.map((row) => row.id), // 提取勾选数据中的id
          userId: this.userId,
        };
        // 发起请求
        const res = await this.$api.post(
          "/input/income-pool-invoice-basic-info-new/batchPDFPrinting",
          params,
        );
        // 更新 pdfUrl
        const pdfUrl = res.data;
        // 在新窗口中打开 PDF
        const newWindow = window.open(pdfUrl);

        // 等待新窗口加载完成后触发打印
        if (newWindow) {
          newWindow.onload = () => {
            newWindow.print(); // 自动调用新窗口的打印功能
          };
        } else {
          this.$message.error("无法打开新窗口，请检查浏览器是否阻止弹窗。");
        }

        // 获取 iframe 引用
        // const iframe = this.$refs.iframe;

        // window.open(this.pdfUrl); // 打开 PDF 文件，让用户自己调用浏览器的打印

        // 检查 iframe 是否存在
        // if (iframe) {
        //   // 监听 iframe 的 load 事件，确保 PDF 加载完成后再调用打印
        //   iframe.onload = () => {
        //     iframe.contentWindow.focus(); // 聚焦 iframe
        //     iframe.contentWindow.print(); // 调用浏览器打印功能
        //   };
        //   // 设置 iframe 的 src 属性，加载 PDF
        //   iframe.src = this.pdfUrl;
        // } else {
        //   throw new Error("Iframe not found");
        // }
      } catch (err) {
        // 打印错误信息
        this.$message.error(err.message || "打印失败");
      }
    },

    /**
     * @description 导出EXCEL
     */
    exportExcelFunc() {
      // const { searchData } = this.$store.state.CompareInvoicePool;

      const params = {
        ids: this.selectedRows.map((row) => row.id),
        userId: this.userId,
      };

      // 创建一个隐藏的表单
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/input/income-pool-invoice-basic-info-new/export"; // API 端点
      form.target = "_blank"; // 新页面打开

      // 将参数添加到表单中
      Object.keys(params).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      });

      // 将表单添加到文档并提交
      document.body.appendChild(form);
      form.submit();

      // 移除表单
      document.body.removeChild(form);
    },

    /**
     * @description 标记推送
     */
    signPushFunc(command) {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      let params = {
        ids: this.selectedRows.map((row) => row.id),
        userId: this.userId,
        systemType: "1",
        type: command,
      };
      this.$api
        .post("/input/income-pool-invoice-basic-info-new/pushInvoice", params)
        .then((res) => {
          this.$message.success(res.message);
          const { searchData } = this.$store.state.CompareInvoicePool;
          this.queryForm = {
            pageNo: searchData.pageNo,
            pageSize: searchData.pageSize,
          };
          this.fetchData(searchData);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    /**
     * @description 推送SEED
     */
    pushSeedFunc(command) {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      // 过滤掉journalNo有值的数据
      const filteredRows = this.selectedRows.filter((row) => !row.journalNo);
      
      if (filteredRows.length === 0) {
        this.$message.warning("所选数据都已推送,无法操作！");
        return;
      }

      let params = {
        ids: filteredRows.map((row) => row.id),
        userId: this.userId,
        systemType: "SEED",
        type: command,
      };
      this.$api
        .post("/input/income-pool-invoice-basic-info-new/pushInvoice", params)
        .then((res) => {
          this.$message.success(res.message);
          const { searchData } = this.$store.state.CompareInvoicePool;
          this.queryForm = {
            pageNo: searchData.pageNo,
            pageSize: searchData.pageSize,
          };
          this.fetchData(searchData);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    /**
     * @description 推送SAP
     */
    pushSapFunc(command) {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      let params = {
        ids: this.selectedRows.map((row) => row.id),
        userId: this.userId,
        systemType: "SAP",
        type: command,
      };
      this.$api
        .post("/input/income-pool-invoice-basic-info-new/pushInvoice", params)
        .then((res) => {
          this.$message.success(res.message);
          const { searchData } = this.$store.state.CompareInvoicePool;
          this.queryForm = {
            pageNo: searchData.pageNo,
            pageSize: searchData.pageSize,
          };
          this.fetchData(searchData);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    /**
     * @description 导入发票
     */
    importInvoiceFunc() {
      this.$refs["inputInvoice"].showImportDialog();
    },

    /**
     * @description 下载PDF
     */
    downloadPdfFunc() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      const params = {
        ids: this.selectedRows.map((row) => row.id),
        userId: this.userId,
      };

      // 创建一个隐藏的表单
      const form = document.createElement("form");
      form.method = "POST";
      form.action =
        "/input/income-pool-invoice-basic-info-new/batchDownloadPdf"; // API 端点
      form.target = "_blank"; // 新页面打开

      // 将参数添加到表单中
      Object.keys(params).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      });

      // 将表单添加到文档并提交
      document.body.appendChild(form);
      form.submit();

      // 移除表单
      document.body.removeChild(form);
    },

    /**
     * @description 更新供应商
     */
    updateSupplierFunc() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条数据！");
        return;
      }

      const ids = this.selectedRows.map((row) => row.id);

      this.$refs["updateSupplier"].showUpdateDialog(ids);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 15px;

  .right-title {
    margin: 12px 10px 0 0;

    .sumTotal {
      font-size: 14px;
      font-weight: bold;
      color: #da5536;
    }
  }

  .btn-group-item {
    margin-left: 10px;
  }
}
::v-deep {
  .el-table__empty-block {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    padding-right: 100%;
  }
}
</style>
